// ABOUTME: Builds a stub API row for a scope with no saved configuration (e.g. a brand-new country default).
// ABOUTME: Config hooks run it through their own transform so the form renders empty and creatable.
import {MetaResponse} from '../types'

const EMPTY_META: MetaResponse = {createdAt: '', updatedAt: '', createdBy: '', updatedBy: ''}

export const emptyApiRow = <T>(scopeId: string, fields: Partial<T> = {}): T =>
  ({scopeId, id: undefined, _meta: EMPTY_META, ...fields}) as unknown as T

export const asNotInherited = <C extends {_meta: {isInherited: boolean}}>(config: C): C => ({
  ...config,
  _meta: {...config._meta, isInherited: false},
})
